//Стор состояний шаблона

import { nextTick, ref } from 'vue';

import { genGUID } from '@/helpers/utils';
import { mainMenu } from '@/api/system';
import {
	confirmUnsavedForPanel,
	unregisterUnsaved,
} from '@/core/unsaved-registry';

export const sidebarHide: any = ref(false);
export const sidebarFullscreen: any = ref(false);
export const sidebarMobile: any = ref(false);
export const navbarMobileShow: any = ref(false);
export const menuItems: any = ref([]);
export const pageTitle: any = ref(null);
export const breadCrumb: any = ref([]);

// breadCrumb.value.push({
// 	route: '/',
// 	icon: 'icon-home2',
// 	caption: 'Домашняя'
// })

// breadCrumb.value.push({
// 	icon: 'icon-file-empty',
// 	caption: 'Dashboard'
// })

export function addBreadCrumb(item: any) {
	breadCrumb.value.push(item);
}

export const fetchMainMenu = async () => {
	menuItems.value = await mainMenu();
}

export const closeSidebar = () => {
	sidebarMobile.value = false;
	sidebarFullscreen.value = false;
	navbarMobileShow.value = false;
}

const activePanels: any = [];

//Массив открытых панелей
export const panels = ref<any>([]);


//ключ открытой панели, если нет открытых панелей или активна основная вкладка то равно null
export const thisPanel = ref(null);
export const thisPanelTab = ref(null);
export const thisPanelTabModal = ref(null);
export const thisPanelModal = ref(null);

//Имя основной вкладки, если пусто то режим работы через модальные панели
export const caption = ref<string>('');

export const setCaption = (value: string) => {
	for (const key in panels.value) {
		if (panels.value[key].modal) return;
	}

	caption.value = value;
}

export const openPanel = (panel: any) => {
	const inferredParentKey =
		panel.parentKey !== undefined
			? panel.parentKey
			: activePanels.length
				? activePanels[activePanels.length - 1]
				: null;

	const _panel: any = Object.assign({
		modal: false,
		modalTab: false,
		scrollable: false,
		key: genGUID(),
		caption: '',
		component: null,
		center: true,
		buttons: ref([]),
		bodyStyle: {},
		dialogClass: {},
		dialogStyle: {},
		closeable: true,
		topPanel: true,//Кнопки управления сверху
		bottomPanel: false,//Кнопки управления снизу,
		closeButtonCaption: 'Закрыть',
		parentKey: inferredParentKey,
		onShow: () => null,
		onCreate: () => ({}),
		onClose: (result: any = null) => result
	}, panel);

	// parentKey из аргумента имеет приоритет; иначе — верхняя активная панель
	if (panel.parentKey === undefined) {
		_panel.parentKey = inferredParentKey;
	}

	//Если есть уже открыте модальные панели, то новая панель только модально
	for (const key in panels.value) {
		if (panels.value[key].modal) {
			_panel.modal = true;

			break;
		}
	}

	for (const key in panels.value) {
		if (panels.value[key].key == _panel.key) {
			activePanel(panels.value[key]);

			return;
		}
	}

	_panel.setButtons = (buttons: any) => _panel.buttons.value = buttons;
	_panel.close = (result: any = true) => result && closePanel(_panel, result);

	if (_panel.center) _panel.dialogClass['modal-dialog-centered'] = _panel.center;

	if (panel.width) _panel.dialogStyle['max-width'] = panel.width;

	if (panel.height) {
		_panel.bodyStyle['height'] = panel.height;
		_panel.bodyStyle['overflow'] = 'scroll';
		_panel.bodyStyle['overflow-x'] = 'hidden';
		_panel.bodyStyle['overflow-y'] = 'auto';
	}

	panels.value.push(_panel);

	activePanels.push(_panel.key);

	setTimeout(() => activePanel(_panel), 0);

	if (panels.value.filter((el: any) => el.modal).length > 0) {
		//Запретить прокрутку документа
		document.body.style.overflow = 'hidden';
	}

	return Object.assign(_panel, _panel.onCreate(_panel));
}

export const closePanel = async (panel: any, result: any = null) => {
	if (!panel || !panel.key) {
		return;
	}

	const _panels = panels.value;
	const panelObj = _panels.find((p: any) => p.key === panel.key);

	if (panelObj && panelObj.closeable) {
		if ((panelObj as any)._processingReceipt === true) {
			return;
		}
		
		if ((panelObj as any)._blockClosing === true) {
			return;
		}
		
		if ((panelObj as any)._blockClosePanel !== undefined) {
			const isProcessing = (panelObj as any)._isProcessingReceipt ? (panelObj as any)._isProcessingReceipt() : false;
			const allowClose = (panelObj as any)._allowClose ? (panelObj as any)._allowClose() : true;
			const blockClosePanel = (panelObj as any)._blockClosePanel;
			if (isProcessing || !allowClose || blockClosePanel === true) {
				return;
			}
		}
	}

	for (const key in _panels) {
		if (_panels[key].key == panel.key && _panels[key].closeable) {

			const close = () => {
				for (const key in activePanels) {
					if (activePanels[key] == panel.key) {
						activePanels.splice(key, 1);

						break;
					}
				}

				if (activePanels.length > 0) {
					const key = activePanels[activePanels.length - 1];

					for (const i in _panels) {
						if (_panels[i].key == key) {
							nextTick(() => activePanel(_panels[i]));

							break;
						}
					}
				} else {
					nextTick(() => activePanel(null));
				}

				unregisterUnsaved(_panels[key].key);
				_panels[key].onClose(result);

				_panels.splice(key, 1);
			}

			const skipUnsaved =
				(panel as any).skipUnsavedGuard === true ||
				(_panels[key] as any).skipUnsavedGuard === true;

			if (!skipUnsaved) {
				const canLeave = await confirmUnsavedForPanel(_panels[key].key);
				if (!canLeave) return;
			}

			if (_panels[key].onBeforeClose) {
				const canClose = await _panels[key].onBeforeClose();
				if (canClose) {
					close();
				}
			} else {
				if ((panel as any)._blockClosePanel && !(panel as any)._allowClose?.()) {
					return;
				}
				close();
			}

			break;
		}
	}

	if (_panels.filter((el: any) => el.modal).length == 0) {
		//Вернуть прокрутку документа если закрыты все модальные окна
		document.body.style.overflowX = 'hidden';
		document.body.style.overflowY = 'inherit';
	}

	setTimeout(() => {
		if (_panels.length == 0) activePanel(null);
	}, 300)
}

export const activePanel = (panel: any) => {
	const _panels = panels.value;

	if (panel) {
		for (const keyA in _panels) {
			if (_panels[keyA].key == panel.key) {
				thisPanel.value = _panels[keyA].key;

				if (_panels[keyA].modal) {
					thisPanelModal.value = _panels[keyA].key;
				} else {
					thisPanelTab.value = _panels[keyA].key;
				}

				for (const keyB in activePanels) {
					if (activePanels[keyB] == panel.key) {
						const _panel = activePanels.splice(keyB, 1);

						activePanels.push(_panel[0])

						break;
					}
				}

				break;
			}
		}
	} else {
		thisPanel.value = null;
		thisPanelTab.value = null;
		thisPanelModal.value = null;
	}
}

export const closeAllPanels = async (): Promise<boolean> => {
	const hasProcessingPanel = panels.value.some((p: any) => (p as any)._processingReceipt === true);
	if (hasProcessingPanel) {
		return false;
	}

	// Закрываем сверху вниз через closePanel (dirty-диалог + onBeforeClose)
	while (panels.value.length > 0) {
		const panel = panels.value[panels.value.length - 1];
		const before = panels.value.length;
		await closePanel(panel);
		if (panels.value.length >= before) {
			// Отмена / блокировка закрытия
			return false;
		}
	}
	return true;
};

export const getThisPanel = () => activePanels.length > 0 ? activePanels[activePanels.length - 1] : null;

document.body.addEventListener('keyup', (e: any) => {
	if (e.keyCode == 27 && activePanels.length > 0 && thisPanel.value) {
		if (e.target.localName == "input" && e.target.type == 'file') return;

		e.stopPropagation();

		closePanel({
			key: activePanels[activePanels.length - 1]
		});
	}
})
